import { getI18nText } from 'pricing-pages-lib/utils/languageUtils';
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import { getOnboardingServicesUrlPublic } from 'pricing-pages-lib/utils/publicPageUrls';
import { HUBSPOT_FOR_STARTUPS_SETUP } from 'self-service-api/constants/ApiNames';
import { usePurchaseOptionsForProductsForTerm } from '../../hooks/usePurchaseOptions';
import { CustomError } from '../../v2/components/error-boundary/CustomErrors';
import { useErrorBoundary } from '../../v2/components/error-boundary/useErrorBoundary';
import { trackClickedLink } from '../../v2/utils/tracking/trackingEventUtils';
import SkeletonLoadWrapper from '../common/loading/SkeletonLoadWrapper';
import { RequiredOnboardingSubtextContent } from './RequiredOnboardingSubtextContent';
import { jsx as _jsx } from "react/jsx-runtime";
const RequiredOnboardingSubtext = ({
  skuIds,
  langKey,
  currencyCode,
  tab,
  trackingSource,
  includesOnboardingCost
}) => {
  var _pricingInfo$oneTimeF, _pricingInfo$oneTimeF2;
  const {
    showBoundary
  } = useErrorBoundary();
  const onboardingServicesUrl = getOnboardingServicesUrlPublic(HUBSPOT_FOR_STARTUPS_SETUP === langKey);
  const handleClick = () => {
    trackClickedLink({
      name: 'onboarding-services',
      value: getI18nText('planBuilder.requiredOnboardingSubtext.learnMore', {
        locale: 'en-us'
      }),
      type: 'external',
      url: onboardingServicesUrl,
      tab,
      trackingSource
    });
  };
  const onboardingIncludedKey = includesOnboardingCost ? 'onboardingIncluded' : 'onboardingNotIncluded';
  const productConfigurations = skuIds.map(skuId => createProductConfig({
    quantity: 1,
    skuId
  }));
  const {
    pricingData: pricingInfo,
    loading: pricingLoading,
    error: pricingError
  } = usePurchaseOptionsForProductsForTerm({
    productConfigurations
  });
  if (pricingError) {
    showBoundary(new CustomError('Error fetching required onboarding pricing data', {
      error: pricingError,
      productConfigurations
    }));
  }
  const fullPrice = pricingInfo === null || pricingInfo === void 0 || (_pricingInfo$oneTimeF = pricingInfo.oneTimeFee) === null || _pricingInfo$oneTimeF === void 0 ? void 0 : _pricingInfo$oneTimeF.fullPrice;
  const calculatedPrice = pricingInfo === null || pricingInfo === void 0 || (_pricingInfo$oneTimeF2 = pricingInfo.oneTimeFee) === null || _pricingInfo$oneTimeF2 === void 0 ? void 0 : _pricingInfo$oneTimeF2.calculatedPrice;
  if ((!(pricingInfo !== null && pricingInfo !== void 0 && pricingInfo.oneTimeFee) || !fullPrice || !calculatedPrice) && !pricingLoading) {
    return null;
  }
  return /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
    isLoading: pricingLoading,
    heights: [40],
    widths: ['100%'],
    children: /*#__PURE__*/_jsx(RequiredOnboardingSubtextContent, {
      langKey: langKey,
      currencyCode: currencyCode,
      fullPrice: fullPrice !== null && fullPrice !== void 0 ? fullPrice : 0,
      calculatedPrice: calculatedPrice !== null && calculatedPrice !== void 0 ? calculatedPrice : 0,
      onboardingIncludedKey: onboardingIncludedKey,
      handleClick: handleClick,
      onboardingServicesUrl: onboardingServicesUrl
    })
  });
};
export default RequiredOnboardingSubtext;